import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/user'

const routes = [
  {
    path: '/',
    component: () => import('@/layouts/LandingLayout.vue'),
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/views/landing/HomeLanding.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { guest: true }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/LoginView.vue'),
    meta: { guest: true }
  },
  {
    path: '/app',
    component: () => import('@/layouts/AppLayout.vue'),
    meta: { auth: true },
    redirect: '/app/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/app/DashboardView.vue'),
        meta: { auth: true }
      },
      {
        path: 'assets/person',
        name: 'assets-person',
        component: () => import('@/views/app/PersonAssetView.vue'),
        meta: { auth: true }
      },
      {
        path: 'assets/environment',
        name: 'assets-environment',
        component: () => import('@/views/app/EnvAssetView.vue'),
        meta: { auth: true }
      },
      {
        path: 'assets/prop',
        name: 'assets-prop',
        component: () => import('@/views/app/PropAssetView.vue'),
        meta: { auth: true }
      },
      {
        path: 'assets/bgm',
        name: 'assets-bgm',
        component: () => import('@/views/app/BgmAssetView.vue'),
        meta: { auth: true }
      },
      {
        path: 'assets/sfx',
        name: 'assets-sfx',
        component: () => import('@/views/app/SfxAssetView.vue'),
        meta: { auth: true }
      },
      {
        path: 'asset-audit',
        name: 'asset-audit',
        component: () => import('@/views/app/AssetAuditView.vue'),
        meta: { auth: true, roles: ['leader', 'vice_leader'] }
      },
      {
        path: 'copyright',
        name: 'copyright',
        component: () => import('@/views/app/CopyrightView.vue'),
        meta: { auth: true }
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@/views/ProfileView.vue'),
        meta: { auth: true }
      }
    ]
  },
  // 兼容旧入口
  {
    path: '/profile',
    redirect: '/app/profile'
  },
  {
    path: '/about',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

router.beforeEach(async (to) => {
  const userStore = useUserStore()
  if (to.meta.auth && !userStore.isLogin) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  if (to.meta.guest && userStore.isLogin) {
    return { name: 'dashboard' }
  }
  if (to.meta.roles?.length) {
    if (!userStore.profile && userStore.isLogin) {
      try {
        await userStore.fetchProfile()
      } catch {
        return { name: 'login' }
      }
    }
    const role = userStore.profile?.staff_role || ''
    if (!to.meta.roles.includes(role)) {
      return { name: 'dashboard' }
    }
  }
  return true
})

export default router
